var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMasterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 22",
    enableBackground: "new 0 0 42 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    d: "M0 0h9v6H0zM11 0h9v6h-9zM22 0h9v6h-9zM33 0h9v6h-9zM0 8h9v6H0zM11 8h9v6h-9zM22 8h9v6h-9zM33 8h9v6h-9zM0 16h9v6H0zM11 16h9v6h-9zM22 16h9v6h-9zM33 16h9v6h-9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterIcon);
export default __webpack_public_path__ + "static/media/master_icon.4275299d7d2d7f5c34afec9952454d43.svg";
export { ForwardRef as ReactComponent };